import React from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import Anamnesis from '../anamnesis/Anamnesis'
import currentUserHasAccess from '../../../../util/widget-helper'
import { ANAMNESIS_LIST_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const AnamnesisList = ({
    isUserFromCustomerStore,
    anamnesisList,
    isIprReadOnly,
    findOrCreateAnamnesis,
    excludeTemplateKeyList = [],
    isIPRProviderStore,
    customerId,
    showAnamnesis,
    changeAnamnesis,
    saveAnamnesis,
    toggleAnamnesis,
    isInfoLegendShown,
    toggleInfoLegend,
}) => {
    if (!currentUserHasAccess(ANAMNESIS_LIST_WIDGET_CONTAINER)) {
        return null
    }

    if (!anamnesisList) {
        return null
    }
    return (
        <div>
            {anamnesisList.map(anamnesis => {
                if (
                    excludeTemplateKeyList.indexOf(anamnesis.templateKey) !== -1
                ) {
                    return null
                }
                return (
                    <Anamnesis
                        skipAuthorization={true}
                        key={anamnesis.id}
                        findOrCreateAnamnesis={findOrCreateAnamnesis}
                        isIPRProviderStore={isIPRProviderStore}
                        isUserFromCustomerStore={isUserFromCustomerStore}
                        anamnesis={anamnesis}
                        readOnly={true}
                        isIprReadOnly={isIprReadOnly}
                        templateKey={anamnesis.templateKey}
                        customerId={customerId}
                        showAnamnesis={showAnamnesis}
                        toggleAnamnesis={toggleAnamnesis}
                        changeAnamnesis={changeAnamnesis}
                        saveAnamnesis={saveAnamnesis}
                        isInfoLegendShown={isInfoLegendShown}
                        toggleInfoLegend={toggleInfoLegend}
                    />
                )
            })}
        </div>
    )
}

export default lifecycle({
    componentDidMount () {
        const { findByCustomerId, customerId } = this.props
        findByCustomerId(customerId)
    },
})(AnamnesisList)

AnamnesisList.propTypes = {
    isUserFromCustomerStore: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/list/AnamnesisList.js